import React from "react";
import { Card, Dropdown, Image, Label } from "semantic-ui-react";
import "../../styles/landing-page.scss";
import "../../styles/main.scss";
import { css } from "@emotion/css";
import BCFixedText from "./BCFixedText";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";

interface BPProps {
    isGreaterThanMobile?;
    infoData;
    handleInfo?;
    displayList; 
    handleExport?;
    handleApplication?;
    isApplication?;
    handleCopyApplication?;
    handleSummary?;
    isSummary?;
    handleGMR?;
    handleCopyGMR?;
    ellipsis?;
    labels?;
    permissions?;
    isKanban?;
    brokerColor?;
    item;
    i;
    ellipsisHandlers?;
}
  
const BCCard = ({ ...props }: BPProps) => {
  const brokerTableEllipsesOverrideCSS = css`
  color: ${props.brokerColor ? props.brokerColor : "black"}!important;
  `;
  const brokerCardOverrideCSS = css`
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 ${props.brokerColor ? props.brokerColor : "black"}, 0 1px 3px 0 #d4d4d5 !important;
  `;
  const CardHeaderContent = ({item}) => {
    return (
      <React.Fragment>
        {props.ellipsis && <Image floated='right'>
          <Dropdown key={"card-dropdown"} className={(props.brokerColor && getIsWhiteLabeled()) ? brokerTableEllipsesOverrideCSS : "icon landing-page-card-header-icon"} icon="ellipsis vertical" pointing='top right'>
            <Dropdown.Menu key={"card-menu"} className="landing-page-card-transform">
              {props.handleExport && <Dropdown.Item key={"export-quote"} onClick={() => props.handleExport(item.id)}>Export Quote</Dropdown.Item>}
              {props.handleGMR && <Dropdown.Item key={"edit-gmr"} onClick={() => props.handleGMR(item)}>Edit Get My Rate</Dropdown.Item>}
              {props.handleCopyGMR && <Dropdown.Item key={"copy-gmr"} onClick={() => props.handleCopyGMR(item, true)}>Copy Get My Rate</Dropdown.Item>}
              {(props.handleApplication && props.isApplication) && <Dropdown.Item key={"edit-application"} onClick={() => props.handleApplication(item)}>Edit Application</Dropdown.Item>}
              {props.handleCopyApplication && <Dropdown.Item key={"copy-application"} onClick={() => props.handleCopyApplication(item)}>Copy Application</Dropdown.Item>}
              {(props.handleSummary && props.isSummary) && <Dropdown.Item key={"view-summary"} onClick={() => props.handleSummary(item.id)}>View Summary</Dropdown.Item>}
              {props.ellipsisHandlers && props.ellipsisHandlers.map((ellipsisHandler, i) => {
                return (
                  <Dropdown.Item key={`ellipsisHandler-${i}`} onClick={() => ellipsisHandler.action(i, item)}>{ellipsisHandler.text}</Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Image>}
        <Card.Header>
          <BCFixedText fixedClass="fixed-card-header" text={item.name} />
        </Card.Header>
      </React.Fragment>
    );
  };
  
    return (
      <Card className="landing-page-card landing-page-card-grow" key={props.item.name + props.i} onClick={() => props.handleSummary && props.handleSummary(props.item.id)}>
        <Card.Content className="landing-page-card-header">
          {props.labels ? props.labels.map((label, j) => {
            if (label.type === "completed" && props.item && label.condition && props.item[label.condition]) {
              return (
                <React.Fragment key={`card-header-${props.i}-${j}`}>
                  <CardHeaderContent item={props.item} />
                  <Label color={label.color} size={"tiny"}>
                    {label.text && label.text}
                    {label.detail && <Label.Detail>{label.detail}</Label.Detail>}
                  </Label>
                </React.Fragment>
              );
            }
            else if (label.type === "progress" && (props.item && label.condition) && !props.item[label.condition]) {
              return (
                <React.Fragment key={`card-header-${props.i}-${j}`}>
                  <CardHeaderContent item={props.item} />
                  <Label color={label.color} size={"tiny"}>
                    {label.text && label.text}
                    {label.detail && <Label.Detail>{label.detail}</Label.Detail>}
                  </Label>
                </React.Fragment>
              );
            }
            else {
              return null;
            }
          }) : <React.Fragment>
            <CardHeaderContent item={props.item} />
          </React.Fragment>}
        </Card.Content>
        <Card.Content className={(props.brokerColor && getIsWhiteLabeled()) ? brokerCardOverrideCSS : "landing-page-card-content"}>
          <Card.Description>
            <div>{props.item.loanProgram}</div>
            {props.item.isPropertySingle ?
              <div>{props.item.numberOfPropertiesOrUnits === 1 ? "Property" : "Properties"}</div> :
              <div>{props.item.numberOfPropertiesOrUnits} {props.item.numberOfPropertiesOrUnits === 1 ? "Unit" : "Units"}</div>
            }
            {props.item.submittedOn && <div>Submitted on {new Date(props.item.submittedOn).toLocaleDateString()}</div>}
            {props.item.brokerage && <div>Brokerage: {props.item.brokerage}</div>}
            {props.item.brokerEmail && <BCFixedText fixedClass="fixed-card-text" text={`Broker Email: ${props.item.brokerEmail}`} />}
          </Card.Description>
        </Card.Content>
      </Card>
    );
};

export default BCCard;